/**
 * Returns the next pitch step for the tilt button cycle.
 * Steps: 0° → 30° → 60° → 85° → 0°
 */
export function nextPitchStep(currentPitch: number): number {
  if (currentPitch < 10) return 30;
  if (currentPitch < 50) return 60;
  if (currentPitch < 75) return 85;
  return 0;
}
